const errorHandler = error => {
    if (error.response) {
        // Request made and server responded
        console.log('error.response', error.response)
        const { data, statusText } = error.response

        const { error: data_error } = data || {}
        const { message: data_message } = data_error || {}

        let message
        if (typeof data_message == 'object') {
            for (const key in data_message) {
                let value = data_message[key]

                if (Array.isArray(value)) {
                    value = value.reduce((_str, item) => {
                        _str +=
                            typeof item == 'string'
                                ? item
                                : JSON.stringify(item) + ' ,'
                        return _str
                    }, '')
                }

                if (typeof value !== 'string') {
                    value = JSON.stringify(value)
                }

                if (message) {
                    message += '-' + value
                } else {
                    message = value
                }
            }
        }
        message = message || data_message || statusText
        if (message.indexOf("Integrity constraint violation:") >= 0 && message.indexOf("location_section_id") >= 0) {
            message = "Location/Section is Required!";
        }
        // For db column limit exceeded
        if (message.indexOf("SQLSTATE[22001]")>=0 ) {
            message = "The data provided is too long for the column. Please check the length and try again!";
        }
        // For Integrity constraint violation
        if (message.indexOf("SQLSTATE[23000]")>=0 ) {
            message = "The operation could not be completed due to a data integrity issue. Please check your input and try again!";
        }
        throw new Error(message)
    } else if (error.request) {
        // The request was made but no response was received
        console.log('error.request:-', error.request)
        throw new Error('Network or System Error!')
    } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error)
        throw new Error(error.message)
    }
}

export { errorHandler }
